module.exports = __webpack_public_path__ + "footer-04.svg?fc9681ae773b9d008a7199f4a6e32bee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer-04.svg
// module id = 87
// module chunks = 0